module.exports = { raw: '8.10.1' };



//////////////////
// WEBPACK FOOTER
// ./~/auth0-js/src/version.js
// module id = 34
// module chunks = 1